var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsClear = function SvgIconsClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 1.333c3.682 0 6.667 2.985 6.667 6.667S11.682 14.667 8 14.667 1.333 11.682 1.333 8 4.318 1.333 8 1.333zm-1.447 4.37c-.237-.185-.581-.168-.8.05-.236.237-.236.62 0 .857L7.143 8l-1.39 1.39-.05.057c-.185.237-.168.581.05.8.237.236.62.236.857 0L8 8.857l1.39 1.39.057.05c.237.185.581.168.8-.05.236-.237.236-.62 0-.857L8.857 8l1.39-1.39.05-.057c.185-.237.168-.581-.05-.8-.237-.236-.62-.236-.857 0L8 7.143l-1.39-1.39z"
  })));
};
export default SvgIconsClear;